import React, {useEffect, useContext} from 'react';
import ProjectContext from '../../context/projects/projectContext';
import Spinner from "../layout/spinner/Spinner";
import imageUrlBuilder from '@sanity/image-url';
import sanityClient from "../../client";
import Swal from "sweetalert2";

const builder = imageUrlBuilder(sanityClient);
const urlFor = (source) => {
  return builder.image(source)
}

const Project = (props) => {
  const projectContext = useContext(ProjectContext);

  const {getProjects, projects, loading, error, clearErrors} = projectContext;

  useEffect(() => {
    getProjects();
    if (document.getElementById('mobile-menu').classList.contains("flex")) {
      document.getElementById('mobile-menu').classList.replace("flex", "hidden");
    }
  }, [])

  useEffect(()=> {
    if (error?.isNetworkError) {
      Swal.fire({
        icon: 'info',
        text: 'Network Error, pls check your internet connection'
      })
      // clear error
    }
  }, [error])

  if (loading)
    return (
      <div className="flex flex-row justify-center items-center h-screen w-screen">
        <Spinner/>
      </div>
    )

  return (
    <div>
      {projects?.map((project, index) => (
        project.name === props.match.params?.name &&
        (
          <div key={index} className="mx-4 md:mx-24 lg:mx-32 py-6">
            <div className="mb-8 grid gap-4 grid-cols-1 lg:grid-cols-2">
              <div>
                <h3 className="text-5xl">{project?.name}</h3>
                <h4 className="text-lg my-4">{project?.description}</h4>
              </div>
              <div>
                <img src={urlFor(project?.previewImage.asset._ref).url()} alt={project.name} loading="lazy"/>
                <div className="flex flex-row justify-between mt-6">
                  <p>Deployed Link: <a href={project?.deployedLink} target="_blank" rel="noreferrer noopener" className="text-blue-400">click here</a></p>
                  <p>Github Link: <a href={project?.githubLink} target="_blank" rel="noreferrer noopener" className="text-blue-400">click here</a></p>
                </div>
              </div>
            </div>

            <div>
              <p className="text-7xl">Gallery</p>
              <div className="grid gap-4 grid-cols-1 lg:grid-cols-2">
                {project?.galleryImage?.map((image, indexNum)=> (
                  <div key={indexNum} className="my-4">
                    <img src={urlFor(image?.asset._ref).url()} alt={project?.name} loading="lazy"/>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
      ))}
    </div>
  );
};

export default Project;
